<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer height="auto">
      <v-spacer />
      <span>&copy;2019 - Setra Systems Inc.</span>
    </v-footer>
  </v-app>
</template>

<script>

import * as auth from './auth';
import ajax from './ajax';

export default {
  name: 'App',
  data() {
    return {
      sidebar: true,
      title: 'Setra powermeter',
    };
  },
  beforeMount() {
    if (auth.getAccessToken()) {
      this.$store.refreshData();
    }
  },
  timers: {
    checkLogin: { time: 4000, repeat: true, autostart: true },
  },
  methods: {
    checkLogin() {
      if (this.$route.name !== 'login') {
        // By doing an AJAX-request, we will check whether the response returns status 401 and
        // redirect to login page if this is the case. See ajax.js in "ajax.interceptors.response.use(...)"
        ajax.get('data/inputs')
          .then((response) => {}) // eslint-disable-line no-unused-vars
          .catch(() => {});
      }
    },
  },
};
</script>

<style>
@import url('~@/assets/colors.css');
@import url('~@/assets/font.css');
</style>
